/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_AddInputs */

const cs_links_add = /** @type {(inputs: Links_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat odkaz`)
};

const en_links_add = /** @type {(inputs: Links_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add link`)
};

/**
* | output |
* | --- |
* | "Add link" |
*
* @param {Links_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_add = /** @type {((inputs?: Links_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_add(inputs)
	return cs_links_add(inputs)
});